export enum ImageExtensions {
  PNG = '.png',
  JPG = '.jpg',
  JPEG = '.jpeg',
  ICO = '.ico'
}
